module.exports = __webpack_public_path__ + "img/about_003.af2b009.png";